import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import your images
import kabiniLogo from '../assets/images/kabini logo.jpg';
import room1 from '../assets/images/room1.jpg';
import room2 from '../assets/images/a2.jpeg';
import room3 from '../assets/images/room3.jpg';
import item1 from '../assets/images/item1.jpg';
import item3 from '../assets/images/item3.jpg';
import hou from '../assets/images/hou.png';
import kabH1 from '../assets/images/kab h1.webp';

const RoomsPage = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 700,
      once: true
    });

    // Preloader hide after page load
    const preloader = document.querySelector('.preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.opacity = '0';
        preloader.style.visibility = 'hidden';
      }, 500);
    }

    // Cleanup function
    return () => {
      // Cleanup if needed
    };
  }, []);

  // SVG Icons Sprites
  const socialIcons = (
    <svg style={{ display: 'none' }}>
      <symbol id="wifi" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M6.55 12.192c3.017-3.256 7.883-3.256 10.9 0a.75.75 0 1 0 1.1-1.02c-3.61-3.896-9.49-3.896-13.1 0a.75.75 0 1 0 1.1 1.02" />
        <path fill="currentColor"
          d="M8.55 14.35c1.912-2.064 4.987-2.064 6.9 0a.75.75 0 1 0 1.1-1.019c-2.506-2.705-6.594-2.705-9.1 0a.75.75 0 1 0 1.1 1.02" />
        <path fill="currentColor"
          d="M10.55 16.51c.808-.872 2.092-.872 2.9 0a.75.75 0 1 0 1.1-1.02c-1.401-1.513-3.699-1.513-5.1 0a.75.75 0 1 0 1.1 1.02" />
        <path fill="currentColor" fillRule="evenodd"
          d="M12 1.25c-.708 0-1.351.203-2.05.542c-.674.328-1.454.812-2.427 1.416L5.456 4.491c-.92.572-1.659 1.03-2.227 1.465c-.589.45-1.041.91-1.368 1.507c-.326.595-.472 1.229-.543 1.978c-.068.725-.068 1.613-.068 2.726v1.613c0 1.904 0 3.407.153 4.582c.156 1.205.486 2.178 1.23 2.947c.747.773 1.697 1.119 2.875 1.282c1.14.159 2.598.159 4.434.159h4.116c1.836 0 3.294 0 4.434-.159c1.177-.163 2.128-.509 2.876-1.282c.743-.769 1.073-1.742 1.23-2.947c.152-1.175.152-2.678.152-4.582v-1.613c0-1.113 0-2-.068-2.726c-.07-.75-.217-1.383-.543-1.978c-.327-.597-.78-1.056-1.368-1.507c-.568-.436-1.306-.893-2.227-1.465l-2.067-1.283c-.973-.604-1.753-1.088-2.428-1.416c-.697-.34-1.34-.542-2.049-.542M8.28 4.504c1.015-.63 1.73-1.072 2.327-1.363c.581-.283.993-.391 1.393-.391s.812.108 1.393.391c.598.29 1.312.733 2.327 1.363l2 1.241c.961.597 1.636 1.016 2.14 1.402c.489.375.77.684.963 1.036c.193.353.306.766.365 1.398c.061.648.062 1.465.062 2.623v1.521c0 1.97-.002 3.376-.14 4.443c-.136 1.048-.393 1.656-.82 2.099c-.425.439-1.003.7-2.004.839c-1.026.142-2.379.144-4.286.144h-4c-1.908 0-3.26-.002-4.286-.144c-1.001-.14-1.579-.4-2.003-.84c-.428-.442-.685-1.05-.82-2.098c-.14-1.067-.141-2.472-.141-4.443v-1.521c0-1.158 0-1.975.062-2.623c.059-.632.172-1.045.365-1.398c.193-.352.474-.661.964-1.036c.503-.386 1.178-.805 2.139-1.402z"
          clipRule="evenodd" />
      </symbol>
      <symbol id="armchair" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M10.749 3.25h2.502c1.088 0 1.976 0 2.678.09c.73.093 1.37.296 1.885.786c.52.496.74 1.12.84 1.833c.096.675.096 1.527.096 2.557v1.057c.4-.21.857-.323 1.323-.323c1.708 0 3.17 1.557 2.53 3.277l-1.12 3l-.023.062c-.173.463-.291.78-.452 1.059c-.498.858-1.309 1.497-2.258 1.833V20a.75.75 0 0 1-1.5 0v-1.254c-.188.004-.4.004-.655.004H6.75V20a.75.75 0 0 1-1.5 0v-1.333a.75.75 0 0 1 .021-.179c-1.14-.398-2.086-1.231-2.527-2.354l-.04-.108l-1.306-3.5c-.642-1.719.82-3.276 2.529-3.276c.466 0 .922.113 1.323.323V8.516c0-1.03 0-1.882.095-2.557c.1-.713.32-1.337.84-1.833c.516-.49 1.156-.693 1.886-.786c.702-.09 1.59-.09 2.678-.09M5.25 11.928V12h.03l.86 2.122l.02.049c.08.196.162.4.289.577c.288.4.724.664 1.199.76c.207.043.427.042.666.042h7.139c.46.001.891.002 1.271-.155c.207-.085.399-.204.566-.355c.316-.286.476-.683.63-1.066l.037-.092l.764-1.882h.03v-.072l.207-.512c.147-.362.57-.666 1.115-.666c.92 0 1.314.743 1.124 1.252l-1.12 3c-.204.55-.278.74-.367.894c-.397.685-1.159 1.193-2.079 1.322c-.212.03-.458.032-1.098.032H6.776c-1.237-.018-2.265-.72-2.636-1.665a6.26 6.26 0 0 1-.034-.09l-1.303-3.493c-.19-.509.204-1.252 1.124-1.252c.546 0 .968.304 1.115.666zm12-.292V8.57c0-1.1-.002-1.845-.08-2.403c-.076-.532-.208-.782-.39-.955c-.188-.18-.465-.312-1.042-.385c-.595-.077-1.386-.078-2.538-.078h-2.4c-1.152 0-1.943.001-2.538.078c-.577.073-.854.206-1.042.385c-.182.173-.314.423-.39.955c-.078.558-.08 1.304-.08 2.403v3.065l.78 1.922c.053.13.083.203.108.259a.502.502 0 0 0 .028.055c.05.07.145.14.28.167c.04.007.095.011.422.011h6.979c.637 0 .738-.014.806-.042a.453.453 0 0 0 .131-.081c.002-.001.022-.017.069-.11a6.79 6.79 0 0 0 .214-.499z"
          clipRule="evenodd" />
      </symbol>
      <symbol id="dumbbells" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="m4.929 1.53l.049.007c.288.04.542.075.753.12c.224.048.452.118.67.252c.482.297.82.777.958 1.324c.069.274.05.636.03.906l-.024.257l4.657.648l.035-.228c.044-.266.112-.623.247-.874a2.103 2.103 0 0 1 1.263-1.034c.247-.071.486-.076.714-.06c.214.013.469.049.757.089l.048.007c.288.04.543.075.753.12c.225.048.452.117.67.251c.482.298.82.778.958 1.324c.061.243.066.48.052.715c-.012.224-.045.492-.083.804l-.35 2.885c-.037.311-.07.58-.111.8c-.043.23-.104.46-.223.681a2.103 2.103 0 0 1-1.263 1.035a2.043 2.043 0 0 1-.714.06c-.214-.014-.468-.05-.756-.09l-.05-.006c-.287-.04-.542-.076-.752-.12a2.071 2.071 0 0 1-.67-.252a2.172 2.172 0 0 1-.958-1.324c-.07-.275-.05-.636-.03-.907c.007-.082.014-.169.023-.257l-4.656-.648l-.036.229c-.044.266-.112.623-.246.873a2.103 2.103 0 0 1-1.264 1.035a2.044 2.044 0 0 1-.713.06c-.214-.014-.47-.05-.757-.09l-.049-.006c-.288-.04-.543-.075-.753-.12a2.072 2.072 0 0 1-.67-.252a2.173 2.173 0 0 1-.958-1.323a2.334 2.334 0 0 1-.052-.715c.013-.224.045-.492.083-.804l.35-2.885c.038-.312.07-.58.112-.8c.043-.23.104-.46.222-.681A2.103 2.103 0 0 1 3.458 1.5c.247-.071.486-.075.714-.06c.214.014.469.05.757.09m-.855 1.407a.63.63 0 0 0-.2.005a.604.604 0 0 0-.357.303a.878.878 0 0 0-.07.247c-.031.167-.058.388-.1.728l-.344 2.84c-.041.34-.068.56-.077.731a.85.85 0 0 0 .009.263a.674.674 0 0 0 .29.413a.648.648 0 0 0 .197.062c.15.032.35.06.67.105c.32.044.52.072.673.082a.63.63 0 0 0 .199-.005a.603.603 0 0 0 .354-.296c0-.002.012-.03.029-.097c.02-.08.042-.188.064-.32c.044-.265.083-.585.123-.92a.75.75 0 0 1 .848-.653l6.132.854a.75.75 0 0 1 .64.833c-.04.335-.078.654-.099.923a4.13 4.13 0 0 0-.015.328c0 .074.006.104.005.104a.673.673 0 0 0 .289.407a.647.647 0 0 0 .197.061c.15.033.35.06.67.105c.32.045.52.072.673.082a.63.63 0 0 0 .199-.005a.604.604 0 0 0 .358-.302a.874.874 0 0 0 .07-.247c.03-.168.058-.388.099-.728L15.944 6c.042-.34.068-.561.078-.732a.826.826 0 0 0-.01-.262a.674.674 0 0 0-.29-.413a.647.647 0 0 0-.197-.062c-.15-.032-.35-.06-.67-.105c-.32-.045-.52-.072-.672-.082a.63.63 0 0 0-.2.005a.603.603 0 0 0-.354.295c0 .003-.011.03-.028.097a4.13 4.13 0 0 0-.064.32a22.38 22.38 0 0 0-.124.92a.75.75 0 0 1-.848.653l-6.131-.853a.75.75 0 0 1-.641-.833c.04-.336.079-.655.1-.924c.01-.133.015-.243.014-.327c0-.074-.005-.104-.005-.105a.672.672 0 0 0-.288-.406a.648.648 0 0 0-.197-.062c-.15-.032-.35-.06-.67-.105a10.5 10.5 0 0 0-.673-.082m15.123 9.309c-.15.032-.345.087-.657.177c-.311.089-.506.145-.652.199a.672.672 0 0 0-.192.091a.706.706 0 0 0-.243.455s0 .03.009.105c.01.084.028.191.054.322c.054.264.132.574.213.901a.75.75 0 0 1-.52.903l-5.973 1.714a.75.75 0 0 1-.934-.539c-.082-.327-.16-.637-.236-.894a4.041 4.041 0 0 0-.103-.307a.73.73 0 0 0-.04-.09a.57.57 0 0 0-.375-.234a.627.627 0 0 0-.197.023c-.15.032-.346.087-.657.177c-.311.089-.507.145-.652.199a.67.67 0 0 0-.192.091a.707.707 0 0 0-.244.462a.901.901 0 0 0 .024.262c.03.167.083.382.166.713l.692 2.767c.083.331.137.546.189.707c.05.155.082.209.097.23a.572.572 0 0 0 .381.243c.01.001.054.006.198-.024c.15-.031.346-.087.657-.176c.311-.09.506-.146.652-.2a.672.672 0 0 0 .192-.091a.707.707 0 0 0 .243-.455s0-.03-.008-.105a4.093 4.093 0 0 0-.055-.322a22.309 22.309 0 0 0-.213-.9a.75.75 0 0 1 .52-.904l5.973-1.714a.75.75 0 0 1 .934.539c.082.327.16.637.236.894c.038.128.073.23.103.308c.024.06.038.086.04.09a.57.57 0 0 0 .375.234c.01.001.054.006.197-.024c.15-.031.346-.087.657-.176c.312-.09.507-.146.652-.2a.67.67 0 0 0 .193-.091a.707.707 0 0 0 .243-.462a.9.9 0 0 0-.023-.262a13.097 13.097 0 0 0-.167-.713l-.692-2.767a12.78 12.78 0 0 0-.189-.706a.854.854 0 0 0-.097-.231a.571.571 0 0 0-.381-.242a.631.631 0 0 0-.198.023m-.308-1.468a2.04 2.04 0 0 1 .715-.04a2.064 2.064 0 0 1 1.698 1.501c.068.212.133.474.21.777l.702 2.81c.076.304.142.566.182.786c.042.232.067.467.037.716a2.206 2.206 0 0 1-.78 1.437a2.1 2.1 0 0 1-.628.34c-.203.075-.45.146-.731.227l-.048.013c-.28.08-.528.152-.738.196a2.043 2.043 0 0 1-.716.041a2.07 2.07 0 0 1-1.39-.854c-.167-.231-.279-.578-.355-.835l-.06-.207l-4.54 1.303c.02.09.04.177.057.262c.054.265.117.621.082.902a2.206 2.206 0 0 1-.78 1.438a2.096 2.096 0 0 1-.628.34c-.202.075-.45.146-.73.227l-.048.013c-.28.08-.528.152-.739.196a2.043 2.043 0 0 1-.715.041a2.07 2.07 0 0 1-1.391-.854a2.275 2.275 0 0 1-.307-.648c-.068-.212-.133-.474-.21-.777l-.702-2.81c-.076-.304-.142-.566-.182-.786a2.335 2.335 0 0 1-.037-.715a2.206 2.206 0 0 1 .78-1.437c.197-.162.413-.262.628-.341c.203-.075.45-.146.732-.226l.047-.014c.28-.08.528-.152.738-.196a2.04 2.04 0 0 1 .716-.04a2.07 2.07 0 0 1 1.39.853c.167.232.279.579.355.835l.06.207l4.54-1.303c-.02-.09-.04-.177-.056-.261c-.055-.266-.118-.622-.083-.903a2.206 2.206 0 0 1 .78-1.437a2.1 2.1 0 0 1 .628-.341c.202-.075.45-.146.73-.226l.048-.014c.28-.08.529-.152.739-.196"
          clipRule="evenodd" />
      </symbol>
      <symbol id="swimming" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M17 3.75a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5M13.75 5.5a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0m-5.31-.87a.671.671 0 0 0-1.013.881l.988 1.152a2.25 2.25 0 0 1-.551 3.394l-3.477 2.086a.75.75 0 1 1-.772-1.286L7.091 8.77a.75.75 0 0 0 .184-1.131l-.988-1.153a2.171 2.171 0 0 1 3.276-2.849l6.5 7.366a.75.75 0 1 1-1.125.992zm-3.87 8.236c.687-1.074 2.157-1.039 2.888-.104c.99 1.267 2.372 2.488 4.542 2.488c2.209 0 3.57-.979 4.505-2.23c.72-.961 2.286-1.119 3.04.024c.626.945 1.304 1.687 2.627 1.998a.75.75 0 1 1-.344 1.46c-1.852-.436-2.807-1.533-3.534-2.631a.28.28 0 0 0-.253-.128a.432.432 0 0 0-.335.176C16.54 15.48 14.76 16.75 12 16.75c-2.842 0-4.611-1.64-5.724-3.065a.304.304 0 0 0-.246-.125a.23.23 0 0 0-.196.114c-.74 1.156-1.695 2.365-3.662 2.828a.75.75 0 1 1-.344-1.46c1.401-.33 2.08-1.14 2.742-2.176m0 5c.687-1.074 2.157-1.039 2.888-.104c.99 1.267 2.372 2.488 4.542 2.488c2.209 0 3.57-.979 4.505-2.23c.72-.962 2.286-1.119 3.04.024c.626.945 1.304 1.687 2.627 1.998a.75.75 0 1 1-.344 1.46c-1.852-.436-2.807-1.533-3.534-2.631a.28.28 0 0 0-.253-.128a.432.432 0 0 0-.335.177C16.54 20.48 14.76 21.75 12 21.75c-2.842 0-4.611-1.64-5.724-3.065a.304.304 0 0 0-.246-.125a.23.23 0 0 0-.196.114c-.74 1.156-1.695 2.365-3.662 2.828a.75.75 0 1 1-.344-1.46c1.401-.33 2.08-1.14 2.742-2.176"
          clipRule="evenodd" />
      </symbol>
      <symbol id="chef-hat" viewBox="0 0 24 24">
        <g fill="none">
          <path fill="currentColor"
            d="M19 18h.75zM5 14.584h.75a.75.75 0 0 0-.45-.687zm14 0l-.3-.687a.75.75 0 0 0-.45.687zM15.75 7a.75.75 0 0 0 1.5 0zm-9 0a.75.75 0 0 0 1.5 0zM7 4.25A5.75 5.75 0 0 0 1.25 10h1.5A4.25 4.25 0 0 1 7 5.75zm10 1.5A4.25 4.25 0 0 1 21.25 10h1.5A5.75 5.75 0 0 0 17 4.25zm-2 15.5H9v1.5h6zm-6 0c-.964 0-1.612-.002-2.095-.067c-.461-.062-.659-.169-.789-.3l-1.06 1.062c.455.455 1.022.64 1.65.725c.606.082 1.372.08 2.294.08zM4.25 18c0 .922-.002 1.688.08 2.294c.084.628.27 1.195.725 1.65l1.061-1.06c-.13-.13-.237-.328-.3-.79c-.064-.482-.066-1.13-.066-2.094zm14 0c0 .964-.002 1.612-.067 2.095c-.062.461-.169.659-.3.789l1.062 1.06c.455-.455.64-1.022.725-1.65c.082-.606.08-1.372.08-2.294zM15 22.75c.922 0 1.688.002 2.294-.08c.628-.084 1.195-.27 1.65-.726l-1.06-1.06c-.13.13-.328.237-.79.3c-.482.064-1.13.066-2.094.066zm-8-17c.214 0 .423.016.628.046l.219-1.484A5.792 5.792 0 0 0 7 4.25zm5-4.5a5.252 5.252 0 0 0-4.973 3.563l1.42.482A3.752 3.752 0 0 1 12 2.75zM7.027 4.813A5.245 5.245 0 0 0 6.75 6.5h1.5c0-.423.07-.828.198-1.205zM17 4.25c-.287 0-.57.021-.847.062l.22 1.484A4.29 4.29 0 0 1 17 5.75zm-5-1.5a3.752 3.752 0 0 1 3.552 2.545l1.42-.482A5.252 5.252 0 0 0 12 1.25zm3.552 2.545c.128.377.198.782.198 1.205h1.5c0-.589-.097-1.156-.277-1.687zM5.75 18v-3.416h-1.5V18zm-.45-4.103A4.251 4.251 0 0 1 2.75 10h-1.5a5.751 5.751 0 0 0 3.45 5.271zm12.95.687V18h1.5v-3.416zm3-4.584a4.251 4.251 0 0 1-2.55 3.897l.6 1.374A5.751 5.751 0 0 0 22.75 10zm-5.5-3.5V7h1.5v-.5zm-9 0V7h1.5v-.5z" />
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 18h14" />
        </g>
      </symbol>
      <symbol id="meditation" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M12 2.75a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5M8.75 4.5a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0M12 9.77a5.9 5.9 0 0 0-.86.052l-.892.15c-2.013.339-3.498 2.102-3.498 4.178a3.25 3.25 0 0 1-1.43 2.696l-.1.069a3.43 3.43 0 0 1-.823.406l-1.157.39a.75.75 0 0 1-.48-1.422l1.159-.39c.163-.055.319-.132.462-.228l.102-.069a1.75 1.75 0 0 0 .767-1.452c0-2.797 2.003-5.195 4.748-5.657l.89-.15A7.273 7.273 0 0 1 12 8.271a7.255 7.255 0 0 1 1.112.072l.89.15c2.746.462 4.748 2.86 4.748 5.657c0 .586.29 1.13.768 1.452l.101.069c.144.096.3.173.463.228l1.158.39a.75.75 0 0 1-.48 1.422l-1.157-.39a3.429 3.429 0 0 1-.822-.406l-.101-.069a3.25 3.25 0 0 1-1.43-2.696c0-2.076-1.485-3.839-3.497-4.178l-.892-.15a5.886 5.886 0 0 0-.86-.051m-3.1 5.78a.75.75 0 1 1 1.2.9l-.924 1.233l-.022.029a4.531 4.531 0 0 1-.34.42a2.75 2.75 0 0 1-1.007.67c-.155.058-.316.098-.52.15l-.035.008l-1.794.449a.935.935 0 0 0 .227 1.841h.684c1.546 0 3.05-.501 4.287-1.429L12.55 18.4a.75.75 0 1 1 .9 1.2l-.904.678l.491.185c.534.2.775.29 1.017.366a9.252 9.252 0 0 0 2.243.407c.253.014.51.014 1.08.014h.939a.935.935 0 0 0 .226-1.841l-1.473-.369a96.02 96.02 0 0 0-.082-.02c-.476-.119-.851-.212-1.186-.406a2.73 2.73 0 0 1-.29-.192c-.308-.234-.54-.543-.833-.936l-.051-.067l-.727-.969a.75.75 0 1 1 1.2-.9l.727.969c.368.491.471.618.591.709c.042.031.086.06.132.087c.13.075.287.121.883.27l1.473.368a2.435 2.435 0 0 1-.59 4.797h-.963c-.539 0-.84 0-1.14-.017a10.753 10.753 0 0 1-2.607-.473c-.286-.09-.567-.195-1.072-.384l-1.432-.537a8.645 8.645 0 0 1-4.733 1.411h-.684a2.435 2.435 0 0 1-.59-4.797l1.793-.448c.255-.064.324-.082.384-.105c.173-.066.33-.17.458-.304c.044-.047.088-.102.246-.313z"
          clipRule="evenodd" />
      </symbol>
      <symbol id="calendar" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M17 14a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-4-5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-6-3a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2" />
        <path fill="currentColor" fillRule="evenodd"
          d="M7 1.75a.75.75 0 0 1 .75.75v.763c.662-.013 1.391-.013 2.193-.013h4.113c.803 0 1.532 0 2.194.013V2.5a.75.75 0 0 1 1.5 0v.827c.26.02.506.045.739.076c1.172.158 2.121.49 2.87 1.238c.748.749 1.08 1.698 1.238 2.87c.153 1.14.153 2.595.153 4.433v2.112c0 1.838 0 3.294-.153 4.433c-.158 1.172-.49 2.121-1.238 2.87c-.749.748-1.698 1.08-2.87 1.238c-1.14.153-2.595.153-4.433.153H9.945c-1.838 0-3.294 0-4.433-.153c-1.172-.158-2.121-.49-2.87-1.238c-.748-.749-1.08-1.698-1.238-2.87c-.153-1.14-.153-2.595-.153-4.433v-2.112c0-1.838 0-3.294.153-4.433c.158-1.172.49-2.121 1.238-2.87c.749-.748 1.698-1.08 2.87-1.238c.233-.031.48-.056.739-.076V2.5A.75.75 0 0 1 7 1.75M5.71 4.89c-1.005.135-1.585.389-2.008.812c-.423.423-.677 1.003-.812 2.009c-.023.17-.042.35-.058.539h18.336c-.016-.19-.035-.369-.058-.54c-.135-1.005-.389-1.585-.812-2.008c-.423-.423-1.003-.677-2.009-.812c-1.027-.138-2.382-.14-4.289-.14h-4c-1.907 0-3.261.002-4.29.14M2.75 12c0-.854 0-1.597.013-2.25h18.474c.013.653.013 1.396.013 2.25v2c0 1.907-.002 3.262-.14 4.29c-.135 1.005-.389 1.585-.812 2.008c-.423.423-1.003.677-2.009.812c-1.027.138-2.382.14-4.289.14h-4c-1.907 0-3.261-.002-4.29-.14c-1.005-.135-1.585-.389-2.008-.812c-.423-.423-.677-1.003-.812-2.009c-.138-1.027-.14-2.382-.14-4.289z"
          clipRule="evenodd" />
      </symbol>
      <symbol id="arrow-right" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M13.47 5.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06l4.72-4.72H4a.75.75 0 0 1 0-1.5h14.19l-4.72-4.72a.75.75 0 0 1 0-1.06"
          clipRule="evenodd" />
      </symbol>
      <symbol id="arrow-left" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M10.53 5.47a.75.75 0 0 1 0 1.06l-4.72 4.72H20a.75.75 0 0 1 0 1.5H5.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0"
          clipRule="evenodd" />
      </symbol>
      <symbol id="send" viewBox="0 0 24 24">
        <g fill="none">
          <path fill="currentColor"
            d="m21.433 4.861l-6 15.5a1 1 0 0 1-1.624.362l-3.382-3.235l-2.074 2.073a.5.5 0 0 1-.853-.354v-4.519L2.309 9.723a1 1 0 0 1 .442-1.691l17.5-4.5a1 1 0 0 1 1.181 1.329ZM19 6.001L8.032 13.152l1.735 1.66L19 6Z" />
        </g>
      </symbol>
      <symbol id="quote" viewBox="0 0 16 16">
        <path fill="currentColor"
          d="M7 7v7H0V6.9c0-4.8 4.5-5.4 4.5-5.4l.6 1.4s-2 .3-2.4 1.9C2.3 6 3.1 7 3.1 7zm9 0v7H9V6.9c0-4.8 4.5-5.4 4.5-5.4l.6 1.4s-2 .3-2.4 1.9c-.4 1.2.4 2.2.4 2.2z" />
      </symbol>
      <symbol id="play" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M9.5 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842l-5.576 3.584a.5.5 0 0 1-.77-.42Z" />
        <path fill="currentColor"
          d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12m11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5a9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5" />
      </symbol>
      <symbol id="navbar-icon" viewBox="0 0 16 16">
        <path
          d="M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5z" />
      </symbol>
      <symbol id="location" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M3.25 10.143C3.25 5.244 7.155 1.25 12 1.25c4.845 0 8.75 3.994 8.75 8.893c0 2.365-.674 4.905-1.866 7.099c-1.19 2.191-2.928 4.095-5.103 5.112a4.2 4.2 0 0 1-3.562 0c-2.175-1.017-3.913-2.92-5.103-5.112c-1.192-2.194-1.866-4.734-1.866-7.099M12 2.75c-3.992 0-7.25 3.297-7.25 7.393c0 2.097.603 4.392 1.684 6.383c1.082 1.993 2.612 3.624 4.42 4.469a2.7 2.7 0 0 0 2.291 0c1.809-.845 3.339-2.476 4.421-4.469c1.081-1.99 1.684-4.286 1.684-6.383c0-4.096-3.258-7.393-7.25-7.393m0 5a2.25 2.25 0 1 0 0 4.5a2.25 2.25 0 0 0 0-4.5M8.25 10a3.75 3.75 0 1 1 7.5 0a3.75 3.75 0 0 1-7.5 0"
          clipRule="evenodd" />
      </symbol>
      <symbol id="phone" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M6.007 3.407c1.68-1.68 4.516-1.552 5.686.544l.649 1.163c.763 1.368.438 3.095-.68 4.227a.63.63 0 0 0-.104.337c-.013.256.078.849.997 1.767c.918.918 1.51 1.01 1.767.997a.63.63 0 0 0 .337-.104c1.131-1.118 2.859-1.443 4.227-.68l1.163.65c2.096 1.17 2.224 4.004.544 5.685c-.899.898-2.093 1.697-3.498 1.75c-2.08.079-5.536-.459-8.958-3.88c-3.421-3.422-3.959-6.877-3.88-8.958c.053-1.405.852-2.6 1.75-3.498m4.376 1.275c-.6-1.074-2.21-1.32-3.315-.214c-.775.775-1.28 1.63-1.312 2.493c-.066 1.736.363 4.762 3.442 7.84c3.08 3.08 6.105 3.509 7.84 3.443c.863-.033 1.72-.537 2.494-1.312c1.106-1.106.86-2.716-.214-3.315l-1.163-.649c-.723-.403-1.74-.266-2.453.448c-.07.07-.516.486-1.307.524c-.81.04-1.791-.324-2.9-1.434c-1.111-1.11-1.475-2.091-1.435-2.902c.038-.791.455-1.237.524-1.307c.714-.713.851-1.729.448-2.452z"
          clipRule="evenodd" />
      </symbol>
      <symbol id="email" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M9.944 3.25h4.112c1.838 0 3.294 0 4.433.153c1.172.158 2.121.49 2.87 1.238c.748.749 1.08 1.698 1.238 2.87c.153 1.14.153 2.595.153 4.433v.112c0 1.838 0 3.294-.153 4.433c-.158 1.172-.49 2.121-1.238 2.87c-.749.748-1.698 1.08-2.87 1.238c-1.14.153-2.595.153-4.433.153H9.944c-1.838 0-3.294 0-4.433-.153c-1.172-.158-2.121-.49-2.87-1.238c-.748-.749-1.08-1.698-1.238-2.87c-.153-1.14-.153-2.595-.153-4.433v-.112c0-1.838 0-3.294.153-4.433c.158-1.172.49-2.121 1.238-2.87c.749-.748 1.698-1.08 2.87-1.238c1.14-.153 2.595-.153 4.433-.153M5.71 4.89c-1.006.135-1.586.389-2.01.812c-.422.423-.676 1.003-.811 2.009c-.138 1.028-.14 2.382-.14 4.289c0 1.907.002 3.262.14 4.29c.135 1.005.389 1.585.812 2.008c.423.423 1.003.677 2.009.812c1.028.138 2.382.14 4.289.14h4c1.907 0 3.262-.002 4.29-.14c1.005-.135 1.585-.389 2.008-.812c.423-.423.677-1.003.812-2.009c.138-1.028.14-2.382.14-4.289c0-1.907-.002-3.261-.14-4.29c-.135-1.005-.389-1.585-.812-2.008c-.423-.423-1.003-.677-2.009-.812c-1.027-.138-2.382-.14-4.289-.14h-4c-1.907 0-3.261.002-4.29.14m-.287 2.63a.75.75 0 0 1 1.056-.096L8.64 9.223c.933.777 1.58 1.315 2.128 1.667c.529.34.888.455 1.233.455c.345 0 .704-.114 1.233-.455c.547-.352 1.195-.89 2.128-1.667l2.159-1.8a.75.75 0 1 1 .96 1.153l-2.196 1.83c-.887.74-1.605 1.338-2.24 1.746c-.66.425-1.303.693-2.044.693c-.741 0-1.384-.269-2.045-.693c-.634-.408-1.352-1.007-2.239-1.745L5.52 8.577a.75.75 0 0 1-.096-1.057"
          clipRule="evenodd" />
      </symbol>
      <symbol id="clock" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M12 2.75a9.25 9.25 0 1 0 0 18.5a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12S17.937 22.75 12 22.75S1.25 17.937 1.25 12M12 7.25a.75.75 0 0 1 .75.75v3.69l2.28 2.28a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1-.22-.53V8a.75.75 0 0 1 .75-.75"
          clipRule="evenodd" />
      </symbol>
      <symbol id="star" viewBox="0 0 512 512">
        <path fill="currentColor"
          d="M394 480a16 16 0 0 1-9.39-3L256 383.76L127.39 477a16 16 0 0 1-24.55-18.08L153 310.35L23 221.2a16 16 0 0 1 9-29.2h160.38l48.4-148.95a16 16 0 0 1 30.44 0l48.4 149H480a16 16 0 0 1 9.05 29.2L359 310.35l50.13 148.53A16 16 0 0 1 394 480" />
      </symbol>
      <symbol id="play-circle" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="m9.5 16.5l7-4.5l-7-4.5zM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8" />
      </symbol>
      <symbol id="facebook" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
      </symbol>
      <symbol id="youtube" viewBox="0 0 32 32">
        <path fill="currentColor"
          d="M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36.13 36.13 0 0 0 2 16a36.13 36.13 0 0 0 .59 6.74a3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36.13 36.13 0 0 0 30 16a36.13 36.13 0 0 0-.59-6.74ZM13.2 20.2v-8.4l7.27 4.2Z" />
      </symbol>
      <symbol id="instagram" viewBox="0 0 256 256">
        <path fill="currentColor"
          d="M128 80a48 48 0 1 0 48 48a48.05 48.05 0 0 0-48-48Zm0 80a32 32 0 1 1 32-32a32 32 0 0 1-32 32Zm48-136H80a56.06 56.06 0 0 0-56 56v96a56.06 56.06 0 0 0 56 56h96a56.06 56.06 0 0 0 56-56V80a56.06 56.06 0 0 0-56-56Zm40 152a40 40 0 0 1-40 40H80a40 40 0 0 1-40-40V80a40 40 0 0 1 40-40h96a40 40 0 0 1 40 40ZM192 76a12 12 0 1 1-12-12a12 12 0 0 1 12 12Z" />
      </symbol>
      <symbol id="twitter" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M22.46 6c-.77.35-1.6.58-2.46.69c.88-.53 1.56-1.37 1.88-2.38c-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29c0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15c0 1.49.75 2.81 1.91 3.56c-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07a4.28 4.28 0 0 0 4 2.98a8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21C16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56c.84-.6 1.56-1.36 2.14-2.23Z" />
      </symbol>
      <symbol id="linkedin" viewBox="0 0 512 512">
        <path fill="currentColor"
          d="M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32Zm-273.3 373.43h-64.18V205.88h64.18ZM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43c0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43Zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44c-17.74 0-28.24 12-32.91 23.69c-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44c42.13 0 74 27.77 74 87.64Z" />
      </symbol>
      <symbol id="search" viewBox="0 0 24 24">
        <path fill="currentColor" fillRule="evenodd"
          d="M11.5 2.75a8.75 8.75 0 1 0 0 17.5a8.75 8.75 0 0 0 0-17.5M1.25 11.5c0-5.66 4.59-10.25 10.25-10.25S21.75 5.84 21.75 11.5c0 2.56-.939 4.902-2.491 6.698l3.271 3.272a.75.75 0 1 1-1.06 1.06l-3.272-3.271A10.21 10.21 0 0 1 11.5 21.75c-5.66 0-10.25-4.59-10.25-10.25"
          clipRule="evenodd" />
      </symbol>
      <symbol id="plus" viewBox="0 0 16 16">
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
      </symbol>
      <symbol id="minus" viewBox="0 0 16 16">
        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
      </symbol>
    </svg>
  );

  // Room data
  const roomsData = [
    {
      id: 1,
      name: 'Grand deluxe',
      price: 269,
      image: room1,
      description: 'Spacious 32m² · city view · max 2 guests',
      features: ['Wi‑Fi', 'Lounge', '10 ft bed'],
      details: {
        bed: 'king size',
        capacity: '2 adults',
        services: 'TV, minibar, rainfall shower'
      },
      placeholder: 'Grand+Deluxe'
    },
    {
      id: 2,
      name: 'Sweet family',
      price: 360,
      image: room3,
      description: 'Two connecting rooms · 45m² · max 4 guests',
      features: ['Wi‑Fi', 'living area', '2 bathrooms'],
      details: {
        bed: '2 queen beds',
        capacity: '4 adults + child',
        extras: 'bathtub, kitchenette'
      },
      placeholder: 'Family+Suite'
    },
    {
      id: 3,
      name: 'Perfect double',
      price: 450,
      image: room2,
      description: 'Deluxe 28m² · premium view · 2 guests',
      features: ['high‑speed wifi', 'work desk', 'smart TV'],
      details: {
        bed: 'queen size',
        capacity: '2 adults',
        view: 'garden / pool'
      },
      placeholder: 'Perfect+Double'
    },
    {
      id: 4,
      name: 'Terrace suite',
      price: 599,
      image: item1,
      description: '50m² private terrace · outdoor seating',
      features: ['lounge', 'gym access', 'bathtub'],
      details: {
        bed: 'king + sofa bed',
        capacity: '3 adults',
        extras: 'coffee machine, bathrobe'
      },
      placeholder: 'Terrace+Suite'
    },
    {
      id: 5,
      name: 'Accessible room',
      price: 299,
      image: hou,
      description: 'wheelchair friendly · roll‑in shower',
      features: ['wifi', 'grab bars', 'low threshold'],
      details: {
        bed: 'double',
        capacity: '2 guests',
        'door width': '90cm'
      },
      placeholder: 'Accessible',
      imageStyle: { width: '50%', display: 'block', margin: 'auto' }
    },
    {
      id: 6,
      name: 'Kabini signature',
      price: 899,
      image: item3,
      description: 'Panoramic view · separate living · butler service',
      features: ['yoga mat', 'breakfast incl.', 'Jacuzzi'],
      details: {
        bed: 'super king',
        capacity: '2 adults + 2 kids',
        amenities: 'VIP welcome'
      },
      placeholder: 'Signature+Suite'
    }
  ];

  const getFeatureIcon = (feature) => {
    const featureLower = feature.toLowerCase();
    if (featureLower.includes('wifi') || featureLower.includes('wi‑fi')) return 'wifi';
    if (featureLower.includes('lounge') || featureLower.includes('living')) return 'armchair';
    if (featureLower.includes('gym')) return 'dumbbells';
    if (featureLower.includes('breakfast')) return 'chef-hat';
    if (featureLower.includes('yoga')) return 'meditation';
    if (featureLower.includes('bathtub') || featureLower.includes('jacuzzi')) return 'swimming';
    return null;
  };

  const handleImageError = (e, placeholder) => {
    e.target.src = `https://placehold.co/600x400/f5f0e9/8a6f5c?text=${placeholder}`;
  };

  // Add CSS styles
  const styles = `
    :root {
      --primary-color: #4CAF50;
      --primary-dark: #388E3C;
      --bg-light: #F8F9FA;
    }

    /* Preloader Styles */
    .preloader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: opacity 0.5s ease, visibility 0.5s ease;
    }

    .loader {
      width: 48px;
      height: 48px;
      border: 5px solid var(--primary-color);
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    /* General Styles */
    body {
      font-family: 'Sora', sans-serif;
    }

    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cormorant Upright', serif;
    }

    .padding-side {
      padding-left: 3rem;
      padding-right: 3rem;
    }

    .padding-large {
      padding: 5rem 0;
    }

    .padding-medium {
      padding: 4rem 0;
    }

    .padding-small {
      padding: 2rem 0;
    }

    /* Header Styles */
    .header-top {
      background-color: #f8f9fa;
      border-bottom: 1px solid #eee;
    }

    .header-top .info li {
      color: #666;
    }

    .header-top .info li svg {
      margin-right: 5px;
      color: #388E3C;
    }

    /* Navbar Styles */
    #primary-header {
      background: white;
      box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }

    .navbar-nav .nav-link {
      position: relative;
      padding: 5px 0 !important;
      color: #333;
      font-weight: 500;
    }

    .navbar-nav .nav-link::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: var(--primary-color);
      transition: width 0.3s ease;
    }

    .navbar-nav .nav-link:hover::after,
    .navbar-nav .nav-link.active::after {
      width: 100%;
    }

    /* Room Card Styles */
    .room-card {
      transition: 0.2s ease;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .room-card:hover .room-image {
      transform: scale(1.02);
    }

    .room-image {
      transition: 0.25s ease;
      height: 260px;
      width: 100%;
    }

    .feature-icon {
      width: 18px;
      height: 18px;
      fill: currentColor;
    }

    .badge-amenity {
      background: #f3f1ec;
      color: #1f2b3a;
      font-size: 0.9rem;
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
    }

    .btn-outline-kabini {
      border: 1px solid #c4a27a;
      color: #1f2b3a;
      background: transparent;
      transition: all 0.3s ease;
    }

    .btn-outline-kabini:hover {
      background: #c4a27a;
      color: #fff;
    }

    .section-title {
      font-size: 2.8rem;
    }

    /* Table styles */
    .table-borderless td {
      border: none;
      padding: 0.25rem 0;
    }

    .table-borderless tr td:first-child {
      color: #666;
      width: 40%;
    }

    /* Social Icons */
    .social-links .social {
      transition: transform 0.3s ease;
    }

    .social-links .social:hover {
      transform: translateY(-3px);
    }

    .social-links svg {
      fill: #666;
      transition: fill 0.3s ease;
    }

    .social-links .social:hover svg {
      fill: var(--primary-color);
    }

    /* Footer Styles */
    #footer ul.nav li {
      margin-bottom: 10px;
    }

    #footer ul.nav li a {
      color: #666;
      text-decoration: none;
      transition: color 0.3s ease;
    }

    #footer ul.nav li a:hover {
      color: var(--primary-color);
    }

    /* Responsive Styles */
    @media (max-width: 768px) {
      .padding-side {
        padding-left: 1rem;
        padding-right: 1rem;
      }

      .display-1 {
        font-size: 3rem;
      }

      .display-2 {
        font-size: 2.5rem;
      }

      .display-3 {
        font-size: 2rem;
      }

      .display-4 {
        font-size: 1.8rem;
      }

      .display-5 {
        font-size: 1.5rem;
      }

      .display-6 {
        font-size: 1.2rem;
      }

      .section-title {
        font-size: 2rem;
      }
    
      .room-card .h3 {
        font-size: 1.5rem;
      }
    }
  `;

  return (
    <div className="rooms-page">
      {/* Inject Styles */}
      <style>{styles}</style>

      {/* SVG Sprites */}
      {socialIcons}

      {/* Preloader */}
      <div className="preloader">
        <div className="loader"></div>
      </div>

      {/* Header */}
      <header id="header">
        <nav className="header-top py-1">
          <div className="container-fluid padding-side">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <ul className="info d-flex flex-wrap list-unstyled m-0">
                <li className="location text-capitalize d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <svg className="me-1" width="15" height="15">
                    <use xlinkHref="#location"></use>
                  </svg> HD Kote Taluk, Karapura, Around Mysore - 571 114
                </li>
                <li className="phone d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <svg className="me-1" width="15" height="15">
                    <use xlinkHref="#phone"></use>
                  </svg>9886228154
                </li>
                <li className="time d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <svg className="me-1" width="15" height="15">
                    <use xlinkHref="#email"></use>
                  </svg>Booking@kabinee.com
                </li>
              </ul>
              <ul className="social-links d-flex flex-wrap list-unstyled m-0">
                <li className="social">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#facebook"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#twitter"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#linkedin"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#instagram"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#youtube"></use>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <nav id="primary-header" className="navbar navbar-expand-lg py-4">
          <div className="container-fluid padding-side">
            <div className="d-flex justify-content-between align-items-center w-100">
              <Link className="navbar-brand" to="/">
                <img src={kabiniLogo} className="logo img-fluid" style={{ width: '15%' }} alt="Kabini Logo" />
              </Link>

              {/* Navbar Toggler Button */}
              <button className="navbar-toggler border-0 d-flex d-lg-none order-3 p-2 shadow-none" type="button"
                data-bs-toggle="offcanvas" data-bs-target="#bdNavbar" 
                aria-controls="bdNavbar" aria-expanded="false">
                <svg className="navbar-icon" width="60" height="60">
                  <use xlinkHref="#navbar-icon"></use>
                </svg>
              </button>

              <div className="header-bottom offcanvas offcanvas-end" id="bdNavbar" aria-labelledby="bdNavbarOffcanvasLabel">
                <div className="offcanvas-header px-4 pb-0">
                  <button type="button" className="btn-close btn-close-black mt-2" data-bs-dismiss="offcanvas"
                    aria-label="Close" data-bs-target="#bdNavbar"></button>
                </div>
                <div className="offcanvas-body align-items-center justify-content-center">
                  <ul className="navbar-nav align-items-center mb-2 mb-lg-0">
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/homestay">Home</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/aabout">About</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/rooms">Rooms</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/kabini-group">Kabini Group</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/blog">Blog</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link active p-0 fw-bold" aria-current="page" to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="padding-large pt-5">
        <div className="container-fluid padding-side" data-aos="fade-up">
          {/* Page Heading */}
          <div className="d-flex flex-wrap align-items-center justify-content-between mb-5">
            <div>
              <h1 className="display-3 fw-normal mb-2">Explore our rooms</h1>
              <p className="col-lg-7 ps-1">
                Choose from our handpicked accommodations, each designed for your comfort. 
                All rates include breakfast and free Wi‑Fi.
              </p>
            </div>
          </div>

          {/* Room Grid */}
          <div className="row g-4 mt-2">
            {roomsData.map((room) => (
              <div key={room.id} className="col-md-6 col-xl-4">
                <div className="room-card bg-white rounded-4 overflow-hidden border">
                  <img 
                    src={room.image} 
                    alt={room.name} 
                    className="room-image"
                    style={room.imageStyle || {}}
                    onError={(e) => handleImageError(e, room.placeholder)}
                  />
                  
                  <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h3 className="h3 fw-normal mb-0">{room.name}</h3>
                      <span className="badge bg-primary px-3 py-2 rounded-pill">
                        ₹{room.price} / night
                      </span>
                    </div>
                    <p className="text-secondary-emphasis small">{room.description}</p>
                    
                    <div className="d-flex flex-wrap gap-2 my-3">
                      {room.features.map((feature, idx) => {
                        const iconId = getFeatureIcon(feature);
                        return (
                          <span key={idx} className="badge-amenity px-3 py-2 rounded-3 d-flex align-items-center gap-1">
                            {iconId && (
                              <svg className="feature-icon">
                                <use xlinkHref={`#${iconId}`}></use>
                              </svg>
                            )}
                            {feature}
                          </span>
                        );
                      })}
                    </div>

                    <table className="table table-borderless small mt-2 mb-3 w-100">
                      <tbody>
                        {Object.entries(room.details).map(([key, value]) => (
                          <tr key={key}>
                            <td>🛏️ {key.charAt(0).toUpperCase() + key.slice(1)}</td>
                            <td>{value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <div className="d-flex gap-2">
                      <Link to="/acontact" className="btn btn-primary w-50 rounded-3 py-2">
                        Book now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Help Section */}
          <div className="row mt-5 pt-4 align-items-center" id="availability">
            <div className="col-lg-6">
              <img 
                src={kabH1} 
                alt="relax" 
                className="img-fluid rounded-4"
                onError={(e) => e.target.style.display = 'none'}
              />
            </div>
            <div className="col-lg-5 offset-lg-1 mt-4 mt-lg-0">
              <h3 className="display-5 fw-normal">Need help choosing?</h3>
              <p style={{ color: 'black' }}>
                Our team is happy to suggest the perfect room for your stay. Call us or send a message.
              </p>
              <div className="d-flex gap-3 mt-4">
                <a href="tel:+919886228154" className="btn btn-outline-kabini rounded-3 px-4 py-2">
                  📞 +91 98862 28154
                </a>
                <Link to="/acontact" className="btn btn-primary rounded-3 px-4 py-2">
                  Contact us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      {/* <section id="footer" className="padding-medium pt-0">
        <hr className="text-black" />
        <div className="container-fluid padding-side padding-small" data-aos="fade-up">
          <footer className="row">
            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <h4 className="display-6 fw-normal">Quick links</h4>
              <ul className="nav flex-column">
                <li className="nav-item"><Link to="/" className="p-0">Home</Link></li>
                <li className="nav-item"><Link to="/aabout" className="p-0">About us</Link></li>
                <li className="nav-item"><Link to="/rooms" className="p-0">Rooms</Link></li>
                <li className="nav-item"><Link to="/acontact" className="p-0">Contact</Link></li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0">
              <h4 className="display-6 fw-normal">Services</h4>
              <ul className="nav flex-column">
                <li className="nav-item"><a href="#" className="p-0">Spa & wellness</a></li>
                <li className="nav-item"><a href="#" className="p-0">Pool</a></li>
                <li className="nav-item"><a href="#" className="p-0">Yoga</a></li>
                <li className="nav-item"><a href="#" className="p-0">Gym</a></li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0">
              <p className="m-0">© 2024 Hotel Kabini.</p>
              <p className="small">All rights reserved.</p>
            </div>
          </footer>
        </div>
      </section> */}
    </div>
  );
};

export default RoomsPage;